import $ from 'jquery';
import Cropper from 'cropperjs';
global.cropper = '';
import { dataURItoBlob } from "@/actions/common/image-base64-to-blob";
import { FILE_SIZES } from '@/imports-files/pages/career/customize-career-page'

export class CustomCropperAction
{
  constructor()
  {
    this.blob_data = '';
  }

  async initialize_cropping_area(type)
  {
    type = type || 'profilepic'
    var image    = document.querySelector('.Cropper__Image');
    var initalize_hash = {dragMode: 'move', aspectRatio: 1, viewMode: 1, cropBoxResizable: false, toggleDragModeOnDblclick: false}
    switch(type){
    case 'logo_image':
      var minCroppedWidth = FILE_SIZES.logo.minWidth;
      var minCroppedHeight = FILE_SIZES.logo.minHeight;
      var maxCroppedWidth = FILE_SIZES.logo.maxWidth;
      var maxCroppedHeight = FILE_SIZES.logo.maxHeight;

      initalize_hash = {
        dragMode: 'move',
        viewMode: 1,
        zoomable: true,
        cropBoxResizable: false,
        background: false,
        aspectRatio: FILE_SIZES.logo.ratio,
        toggleDragModeOnDblclick: false,
//         data: {
//           width: (minCroppedWidth + maxCroppedWidth) / 2,
//           height: (minCroppedHeight + maxCroppedHeight) / 2,
//         },
//
//         crop: function (event) {
//           var width = Math.round(event.detail.width);
//           var height = Math.round(event.detail.height);
//           console.log(`width ${width} * ${height}`)
//           if (
//             width < minCroppedWidth
//             || height < minCroppedHeight
//             || width > maxCroppedWidth
//             || height > maxCroppedHeight
//           ) {
//             cropper.setData({
//               width: Math.max(minCroppedWidth, Math.min(maxCroppedWidth, width)),
//               height: Math.max(minCroppedHeight, Math.min(maxCroppedHeight, height)),
//             });
//           }
//         }
      }
      cropper = await new Cropper(image, initalize_hash);
      break;
    case 'hero_image':
      var minCroppedWidth = FILE_SIZES.hero.minWidth;
      var minCroppedHeight = FILE_SIZES.hero.minHeight;
      var maxCroppedWidth = FILE_SIZES.hero.maxWidth;
      var maxCroppedHeight = FILE_SIZES.hero.maxHeight;

      initalize_hash = {
        dragMode: 'move',
        viewMode: 1,
        zoomable: true,
        cropBoxResizable: false,
        aspectRatio: FILE_SIZES.hero.ratio,
        toggleDragModeOnDblclick: false,
//         data: {
//           width: (minCroppedWidth + maxCroppedWidth) / 2,
//           height: (minCroppedHeight + maxCroppedHeight) / 2,
//         },
//
//         crop: function (event) {
//           var width = Math.round(event.detail.width);
//           var height = Math.round(event.detail.height);
//           console.log(`width ${width} * ${height}`)
//           if (
//             width < minCroppedWidth
//             || height < minCroppedHeight
//             || width > maxCroppedWidth
//             || height > maxCroppedHeight
//           ) {
//             cropper.setData({
//               width: Math.max(minCroppedWidth, Math.min(maxCroppedWidth, width)),
//               height: Math.max(minCroppedHeight, Math.min(maxCroppedHeight, height)),
//             });
//           }
//         }
      }
      cropper = await new Cropper(image, initalize_hash);
      break;
    case 'mobile_image':
      var minCroppedWidth = FILE_SIZES.mobile_hero.minWidth;
      var minCroppedHeight = FILE_SIZES.mobile_hero.minHeight;
      var maxCroppedWidth = FILE_SIZES.mobile_hero.maxWidth;
      var maxCroppedHeight = FILE_SIZES.mobile_hero.maxHeight;

      initalize_hash = {
        dragMode: 'move',
        viewMode: 1,
        zoomable: true,
        cropBoxResizable: false,
        aspectRatio: FILE_SIZES.mobile_hero.ratio,
        toggleDragModeOnDblclick: false
      }
      cropper = await new Cropper(image, initalize_hash);
      break;
    case 'about_image':
      var minCroppedWidth = FILE_SIZES.about.minWidth;
      var minCroppedHeight = FILE_SIZES.about.minHeight;
      var maxCroppedWidth = FILE_SIZES.about.maxWidth;
      var maxCroppedHeight = FILE_SIZES.about.maxHeight;

      initalize_hash = {
        dragMode: 'move',
        viewMode: 1,
        zoomable: true,
        cropBoxResizable: false,
        aspectRatio: FILE_SIZES.about.ratio,
        toggleDragModeOnDblclick: false,
//         data: {
//           width: (minCroppedWidth + maxCroppedWidth) / 2,
//           height: (minCroppedHeight + maxCroppedHeight) / 2,
//         },
//
//         crop: function (event) {
//           var width = Math.round(event.detail.width);
//           var height = Math.round(event.detail.height);
//           console.log(`width ${width} * ${height}`)
//           if (
//             width < minCroppedWidth
//             || height < minCroppedHeight
//             || width > maxCroppedWidth
//             || height > maxCroppedHeight
//           ) {
//             cropper.setData({
//               width: Math.max(minCroppedWidth, Math.min(maxCroppedWidth, width)),
//               height: Math.max(minCroppedHeight, Math.min(maxCroppedHeight, height)),
//             });
//           }
//         }
      }
      cropper = await new Cropper(image, initalize_hash);
      break;
    case 'gallery_image':
      var minCroppedWidth = FILE_SIZES.gallery.minWidth;
      var minCroppedHeight = FILE_SIZES.gallery.minHeight;
      var maxCroppedWidth = FILE_SIZES.gallery.maxWidth;
      var maxCroppedHeight = FILE_SIZES.gallery.maxHeight;

      initalize_hash = {
        dragMode: 'move',
        viewMode: 1,
        zoomable: true,
        cropBoxResizable: false,
        aspectRatio: FILE_SIZES.gallery.ratio,
        toggleDragModeOnDblclick: false,
//         data: {
//           width: (minCroppedWidth + maxCroppedWidth) / 2,
//           height: (minCroppedHeight + maxCroppedHeight) / 2,
//         },
//
//         crop: function (event) {
//           var width = Math.round(event.detail.width);
//           var height = Math.round(event.detail.height);
//           console.log(`width ${width} * ${height}`)
//           if (
//             width < minCroppedWidth
//             || height < minCroppedHeight
//             || width > maxCroppedWidth
//             || height > maxCroppedHeight
//           ) {
//             cropper.setData({
//               width: Math.max(minCroppedWidth, Math.min(maxCroppedWidth, width)),
//               height: Math.max(minCroppedHeight, Math.min(maxCroppedHeight, height)),
//             });
//           }
//         }
      }
      cropper = await new Cropper(image, initalize_hash);
      break;
    case 'benefit_image':
      var minCroppedWidth = FILE_SIZES.benefit.minWidth;
      var minCroppedHeight = FILE_SIZES.benefit.minHeight;
      var maxCroppedWidth = FILE_SIZES.benefit.maxWidth;
      var maxCroppedHeight = FILE_SIZES.benefit.maxHeight;

      initalize_hash = {
        dragMode: 'move',
        viewMode: 0,
        zoomable: true,
        cropBoxResizable: false,
        aspectRatio: FILE_SIZES.benefit.ratio,
        toggleDragModeOnDblclick: false,
//         data: {
//           width: (minCroppedWidth + maxCroppedWidth) / 2,
//           height: (minCroppedHeight + maxCroppedHeight) / 2,
//         },
//
//         crop: function (event) {
//           var width = Math.round(event.detail.width);
//           var height = Math.round(event.detail.height);
//           console.log(`width ${width} * ${height}`)
//           if (
//             width < minCroppedWidth
//             || height < minCroppedHeight
//             || width > maxCroppedWidth
//             || height > maxCroppedHeight
//           ) {
//             cropper.setData({
//               width: Math.max(minCroppedWidth, Math.min(maxCroppedWidth, width)),
//               height: Math.max(minCroppedHeight, Math.min(maxCroppedHeight, height)),
//             });
//           }
//         }
      }
      cropper = await new Cropper(image, initalize_hash);
      break;
    case 'team_image':
      var minCroppedWidth = FILE_SIZES.team.minWidth;
      var minCroppedHeight = FILE_SIZES.team.minHeight;
      var maxCroppedWidth = FILE_SIZES.team.maxWidth;
      var maxCroppedHeight = FILE_SIZES.team.maxHeight;

      initalize_hash = {
        dragMode: 'move',
        viewMode: 1,
        zoomable: true,
        cropBoxResizable: false,
        aspectRatio: FILE_SIZES.team.ratio,
        toggleDragModeOnDblclick: false,
//         data: {
//           width: (minCroppedWidth + maxCroppedWidth) / 2,
//           height: (minCroppedHeight + maxCroppedHeight) / 2,
//         },
//
//         crop: function (event) {
//           var width = Math.round(event.detail.width);
//           var height = Math.round(event.detail.height);
//           console.log(`width ${width} * ${height}`)
//           if (
//             width < minCroppedWidth
//             || height < minCroppedHeight
//             || width > maxCroppedWidth
//             || height > maxCroppedHeight
//           ) {
//             cropper.setData({
//               width: Math.max(minCroppedWidth, Math.min(maxCroppedWidth, width)),
//               height: Math.max(minCroppedHeight, Math.min(maxCroppedHeight, height)),
//             });
//           }
//         }
      }
      cropper = await new Cropper(image, initalize_hash);
      break;
    case 'profilepic':
      cropper = await new Cropper(image, {
                                            dragMode: 'move',
                                            aspectRatio: 1,
                                            viewMode: 1,
                                            cropBoxResizable: false,
                                            toggleDragModeOnDblclick: false
                                         });
      break;
    }
  }

  async crop_image(args)
  {
    args = args || {}
    let cropper_type = args.cropper_type || {}
    if(Object.keys(cropper_type).length > 0)
    {
      let type = cropper_type.type
      switch(type){
      case 'logo_image':
        var croppedCanvas = cropper.getCroppedCanvas();
        var data_url = croppedCanvas.toDataURL('image/png');
        cropper_type.formik.setFieldValue(`logo_url`, data_url)
        var blob_data       = await dataURItoBlob(data_url);
        await args.viewProfileAction.updateLogo(blob_data)
        this.destroy_cropper();
        break;
      case 'hero_image':
        var result = document.querySelector('#Hero_Back_Image')
        var croppedCanvas = cropper.getCroppedCanvas();
        var data_url = croppedCanvas.toDataURL('image/jpeg');
        result.style.backgroundImage = `url(${data_url})`
        var blob_data       = await dataURItoBlob(data_url);
        await args.viewProfileAction.updateBackground(blob_data)
        this.destroy_cropper();
        await args.viewProfileAction.handleMobileBackground(args.viewProfileAction)
        break;
      case 'mobile_image':
        // var result = document.querySelector('#Hero_Back_Image')
        var croppedCanvas = cropper.getCroppedCanvas();
        var data_url = croppedCanvas.toDataURL('image/jpeg');
        // result.style.backgroundImage = `url(${data_url})`
        var blob_data       = await dataURItoBlob(data_url);
        await args.viewProfileAction.updateMobileBackground(blob_data)
        this.destroy_cropper();
        break;
      case 'about_image':
        var croppedCanvas = cropper.getCroppedCanvas();
        var data_url = croppedCanvas.toDataURL('image/jpeg');
        cropper_type.formik.setFieldValue(`page_sections_attributes.${cropper_type.index}.career_about_section_attributes.image_url`, data_url)
        var blob_data       = await dataURItoBlob(data_url);
        await args.viewProfileAction.updateAboutImage(cropper_type.formik, cropper_type.index, blob_data)
        this.destroy_cropper();
        break;
      case 'gallery_image':
        var croppedCanvas = cropper.getCroppedCanvas();
        var data_url = croppedCanvas.toDataURL('image/jpeg');
        cropper_type.formik.setFieldValue(`page_sections_attributes.${cropper_type.index}.career_gallery_section_attributes.career_gallery_images_attributes.${cropper_type.gallery_index}.image_url`, data_url)
        var blob_data       = await dataURItoBlob(data_url);
        await args.viewProfileAction.updateGalleryImage(cropper_type.formik, cropper_type.index, cropper_type.gallery_index, blob_data)
        this.destroy_cropper();
        break;
      case 'benefit_image':
        var croppedCanvas = cropper.getCroppedCanvas();
        var data_url = croppedCanvas.toDataURL('image/png');
        cropper_type.formik.setFieldValue(`page_sections_attributes.${cropper_type.index}.career_benefit_section_attributes.career_benefit_details_attributes.${cropper_type.benefit_index}.image_url`, data_url)
        var blob_data       = await dataURItoBlob(data_url);
        await args.viewProfileAction.updateBenefitImage(cropper_type.formik, cropper_type.index, cropper_type.benefit_index, blob_data)
        this.destroy_cropper();
        break;
      case 'team_image':
        var croppedCanvas = cropper.getCroppedCanvas();
        var data_url = croppedCanvas.toDataURL('image/png');
        cropper_type.formik.setFieldValue(`page_sections_attributes.${cropper_type.index}.career_team_section_attributes.career_team_details_attributes.${cropper_type.team_index}.image_url`, data_url)
        var blob_data       = await dataURItoBlob(data_url);
        await args.viewProfileAction.updateTeamImage(cropper_type.formik, cropper_type.index, cropper_type.team_index, blob_data)
        this.destroy_cropper();
        break;
      }
    }
    else{
      var result = document.querySelector('#User_Profile');
      var croppedCanvas = cropper.getCroppedCanvas();
      var roundedCanvas = this.getRoundedCanvas(croppedCanvas);
      result.src = roundedCanvas.toDataURL('image/jpeg');
      this.destroy_cropper();
    }
  }

  destroy_cropper()
  {
    cropper.destroy();
  }


  getRoundedCanvas(sourceCanvas) 
  {
    var canvas = document.createElement('canvas');
    var context = canvas.getContext('2d');
    var width = sourceCanvas.width;
    var height = sourceCanvas.height;

    canvas.width = width;
    canvas.height = height;
    context.imageSmoothingEnabled = true;
    context.drawImage(sourceCanvas, 0, 0, width, height);
    context.globalCompositeOperation = 'destination-in';
    context.beginPath();
    context.arc(width / 2, height / 2, Math.min(width, height) / 2, 0, 2 * Math.PI, true);
    context.fill();
    return canvas;
  }

  zoom_in()
  {
    cropper.zoom(0.1);
  }


  zoom_out()
  {
    cropper.zoom(-0.1);
  }
}